// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3wGw8","alert":"SettungsInbox_alert__2h9BK"};